// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".news__list[data-v-5deb66a0]{display:flex;flex-direction:row;justify-content:flex-start;flex-wrap:wrap;margin-top:102px}@media(max-width:475px){.news__list[data-v-5deb66a0]{margin-top:56px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
